import styled from 'styled-components';

export const WrapMediaPreview = styled.div`
  width: 100%;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  background: #000;
  width: 100%;
  height: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
WrapMediaPreview.displayName = 'WrapMediaPreview';

export const MediaPreviewInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
MediaPreviewInner.displayName = 'MediaPreviewInner';
